import React from "react";
import { Result } from "antd";
import { useTranslation } from "react-i18next";

/**
 * Lo que se muestra en lugar del contenido de una sección cuando el backend responde 403.
 *
 * Sin esto, un 403 dejaba la pantalla con la tabla en su estado vacío —"no hay datos"— más el toast
 * del interceptor, que se va en segundos. El usuario terminaba leyendo "esta sección está vacía" en
 * vez de "no tenés permiso para verla", y el botón de alta seguía ahí, listo para otro 403.
 *
 * El 403 es la respuesta correcta y no hay nada que reintentar: la sección existe, el permiso no.
 * Por eso esto es un estado final de la pantalla y no un error recuperable.
 *
 * Ojo: **no** vale para un 401. Ese lo maneja el interceptor de `utilities/axios`, que borra el
 * token y redirige al login, porque significa que la sesión se murió.
 */
export const SectionForbidden: React.FC<{
  title?: string;
  description?: string;
}> = ({ title, description }) => {
  const { t } = useTranslation();

  return (
    <Result
      status="403"
      title={title ?? t("permissions.forbidden.title")}
      subTitle={description ?? t("permissions.forbidden.subtitle")}
    />
  );
};
